import { Logger } from "@spawn/common";
import { Align, Layout as Base, DrawableRectangle, Stretch, View } from "@spawn/core";
import Color from "color";
import Victor from "victor";

export class Layout extends Base {
	/** Returns a {@link Layout} with {@Align.CenterHorizontal} and {@Align.CenterVertical}. */
	public static center(): Layout {
		return new Layout(Align.CenterHorizontal, Align.CenterVertical);
	}

	/** Returns a {@link Layout} with {@Align.CenterHorizontal} and {@Align.Top}. */
	public static top(): Layout {
		return new Layout(Align.CenterHorizontal, Align.Top);
	}

	/** Returns a {@link Layout} with {@Align.CenterHorizontal} and {@Align.Bottom}. */
	public static bottom(): Layout {
		return new Layout(Align.CenterHorizontal, Align.Bottom);
	}
}

export function debugView(v: View, c = "blue", lw = 3): void {
	v.addChild(
		new DrawableRectangle({
			fillAlpha: 0,
			layout: new Layout(Stretch.Horizontal, Stretch.Vertical),
			lineColor: new Color(c),
			lineWidth: lw,
		})
	);
}

/**
 *  listen to arrow events, move view, then log the new position
 */
export const movable = (view: View): void => {
	const move = (x: number, y: number): void => {
		view.position = new Victor(x, y);
		Logger.log(`Moved to ${view.position.x}, ${view.position.y}`);
	};
	const scale = (factor: number): void => {
		view.scale = new Victor(factor, factor);
		Logger.log(`Scaled to ${view.scale.x}, ${view.scale.y}`);
		Logger.log(`Size is now ${view.size.x}, ${view.size.y}`);
	};

	globalThis.addEventListener("keydown", (e) => {
		const { x, y } = view.position;
		switch (e.key) {
			case "ArrowUp":
				move(x, y - 1);
				break;
			case "ArrowDown":
				move(x, y + 1);
				break;
			case "ArrowLeft":
				move(x - 1, y);
				break;
			case "ArrowRight":
				move(x + 1, y);
				break;
			case "-":
				scale(view.scale.x - 0.01);
				break;
			case "=":
				scale(view.scale.x + 0.01);
				break;
		}
	});
};
